var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lf-control-action',{attrs:{"icon":"mdi-view-grid-plus","dense":_vm.dense,"title":_vm.titleMessage},on:{"click":function($event){return _vm.showModal()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }